import { render, staticRenderFns } from "./UploadImgRegister.vue?vue&type=template&id=05a3187b&scoped=true&"
import script from "./UploadImgRegister.vue?vue&type=script&lang=js&"
export * from "./UploadImgRegister.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgRegister.vue?vue&type=style&index=0&id=05a3187b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3187b",
  null
  
)

export default component.exports